import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import { dateDifferenceInDaysFromToday } from '../../helpers/helperFunctions';
import { CaptionText, H3, P1, P3 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { color, colors } from '../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioDiamond,
  IconPortfolioOffice
} from '../../styles/Icons';
import { UserTypes } from '../../types/loginTypes';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';

export const MembershipStatus = () => {
  const { t } = useTranslation('my_hubs');
  const history = useHistory();

  const { currentVirtualOfficeLicence, lifetimeRank, qualifiedRank } =
    useAppSelector((state) => state.portfolio);

  const { userInfo } = useAppSelector((state) => state.auth);

  const isRestrictedUser = userInfo.userType === UserTypes.Restricted;

  return (
    <>
      <Flexed mb='20' mt='20' between alignEnd>
        <H3 color={colors.neutral900}>{t('my_membership_status')}</H3>
      </Flexed>
      <SummaryGrid>
        <BoxPortfolio hasButton>
          <Flexed center>
            <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
              <IconPortfolioOffice />
            </Icon>
            <div>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('backoffice_subscription')}
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {dateDifferenceInDaysFromToday(
                  currentVirtualOfficeLicence?.dateEnd
                )}
                <P3 mb='1'>{t('days_left')}</P3>
              </P1>
            </div>
          </Flexed>
          {!isRestrictedUser && (
            <Button
              w='100px'
              h='34px'
              onClick={() =>
                history.push('/backoffice/settings/virtual-office')
              }>
              {t('add_time')}
            </Button>
          )}
        </BoxPortfolio>

        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioDiamond />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('current_rank')}
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {lifetimeRank}
            </P1>
          </div>
        </BoxPortfolio>

        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioDiamond />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              {t('qualified_rank')}
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {qualifiedRank}
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>
    </>
  );
};
